<p class="form-inline-message">
  <ng-content></ng-content>
</p>